import appleWatchSide from '@/assets/device-icons/apple-watch-side.svg';

interface AppleWatchSideIconProps {
  className?: string;
}

export const AppleWatchSideIcon = ({ className = "h-5 w-5" }: AppleWatchSideIconProps) => {
  return (
    <img 
      src={appleWatchSide} 
      alt="Apple Watch Side View" 
      className={className}
    />
  );
};
